export default function parkingLotPopup(model) {
	return `<div class='content-wrapper parking-lot-popup clearfix' data-key='${model.key}'>
	<h3 id='popup-name'>${model.data.name}</h3>
	<p>${model.data.street_address}<br /><a class='lot-directions'
			href='https://maps.google.com/?daddr=${model.data.latlng}'>Directions&nbsp;
			<svg aria-hidden='true' width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M352 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zm36-320h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zm1372 320q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zm160-96v384q0 14-9 23t-23 9h-96v128q0 80-56 136t-136 56-136-56-56-136v-128h-1024v128q0 80-56 136t-136 56-136-56-56-136v-128h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h768q98 0 179 63.5t104 157.5l105 419h28q93 0 158.5 65.5t65.5 158.5z' />
			</svg></a></p>

	${model.data.availability != null ? `
	<p data-object-id='${model.id}' class='parking-availability'>
		<span class='parking-available'>${model.data.availability}</span>
		<strong>spaces available now.</strong>
	</p>
	` : ''}
	<div class='uw-popup-text'>
		<div>
			<p class='accessible'>Accessible stalls available on first-come, first-served basis.</p>
			<p class='lot-hours'>
				${model.data.hours || ''}
			</p>
			<p>
				<a href='https://transportation.wisc.edu/permits/parking-permit-options/'>UW parking permit options</a>
			</p>
		</div>
	</div>
</div>`;
}
